import { render, staticRenderFns } from "./usuarioQuicktable.vue?vue&type=template&id=65e06ec3&"
import script from "./usuarioQuicktable.vue?vue&type=script&lang=js&"
export * from "./usuarioQuicktable.vue?vue&type=script&lang=js&"
import style0 from "./usuarioQuicktable.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports